import events from 'events';

const EventCenter = events.EventEmitter;

export default EventCenter;
